/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Select_All_ButtonInputs */

const en_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All`)
};

const fr_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout sélectionner`)
};

const de_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle auswählen`)
};

const it_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutto`)
};

const ru_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать все`)
};

const es_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todo`)
};

const zh_cn2_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全选`)
};

const ja_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて選択`)
};

const hi_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबका चयन करें`)
};

const pt_pt2_team_share_select_all_button = /** @type {(inputs: Team_Share_Select_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar tudo`)
};

/**
* | output |
* | --- |
* | "Select All" |
*
* @param {Team_Share_Select_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_select_all_button = /** @type {((inputs?: Team_Share_Select_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Select_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_select_all_button(inputs)
	if (locale === "de") return de_team_share_select_all_button(inputs)
	if (locale === "it") return it_team_share_select_all_button(inputs)
	if (locale === "ru") return ru_team_share_select_all_button(inputs)
	if (locale === "es") return es_team_share_select_all_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_select_all_button(inputs)
	if (locale === "ja") return ja_team_share_select_all_button(inputs)
	if (locale === "hi") return hi_team_share_select_all_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_select_all_button(inputs)
	return en_team_share_select_all_button(inputs)
});